module.exports = __webpack_public_path__ + "392edc2cfae7a3356ff5c9584a2f23bb.fbx";